import '../styles/main.styl';

import { initSwiper } from './components/swiper';
import { initInstrumentCanvas, initCatalogCanvases, initInstrumentAR, initHomeCanvas, stopAll3DInstances } from './components/three';
import { initAudioVisualizer } from './components/audioVisualizer';
import { initRNBO } from './components/rnbo';


document.addEventListener("DOMContentLoaded", function() {

    // Body load
    const bodyElement = document.getElementById("body");
    if (bodyElement) bodyElement.classList.add("body--loaded");


    // Header menu interaction
    const hamburger = document.querySelector('.header__hamburger');
    const menu = document.querySelector('.header__menu');
    const closeMenu = document.querySelector('.header__menu__close');
  
    if (hamburger && menu && closeMenu) {
      hamburger.addEventListener('click', () => {
        menu.classList.add('_open');
      });
  
      closeMenu.addEventListener('click', () => {
        menu.classList.add('_closing');
        setTimeout(function(){
            menu.classList.remove('_closing');
            menu.classList.remove('_open');
        },500)
      });
    }



    // SWIPER
    initSwiper();
    
    // THREE JS
    initInstrumentCanvas();
    initCatalogCanvases();
    initInstrumentAR();
    initHomeCanvas();

    // AUDIO VISUALIZER
    initAudioVisualizer();

    // RNBO
    initRNBO();

    
});

